import {
  Box,
  Button,
  makeStyles,
  SwipeableDrawer,
  Typography,
} from "@material-ui/core";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import { ToggleButton } from "@material-ui/lab";
import { React, useState } from "react";
import { useTranslate } from "react-admin";
import { useHistory, useLocation } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  onReportContainer: {
    width: 4,
    height: "100%",
    backgroundColor: "#F4F4F4",
    display: "grid",
    justifyContent: "center",
    fontSize: 30,
    position: "absolute",
    top: 20,
    left: 10,
  },
  container: {
    width: 4,
    // height: "140%",
    // backgroundColor: "#DDDDDF",
    display: "grid",
    justifyContent: "center",
    marginTop: -60,
    marginLeft: 28,
    position: "absolute"
  },
  fullStyleContainer: { 
    marginLeft: 5,
  },
  background: {
    backgroundColor: "orange",
    height: "100%",
  },

  button: {
    width: 36,
    height: 36,
    minWidth: 36,
    minHeight: 36,
    borderRadius: "50%",
    backgroundColor: "#FFFFFF",
    boxShadow: "0px 0px 6px rgba(0, 0, 0, 0.30)",
    top: 40,
    left: 4
  },
  fullStyleButton: {
    width: 160,
    borderRadius: 36,
    height: 36,
    minWidth: 36,
    minHeight: 36,
    backgroundColor: theme.white,
    left: 80,
    marginLeft: 28,
    filter: "drop-shadow(0px 0px 6px rgba(0, 0, 0, 0.25))",
    marginTop:55,
  },
  moreReport: {
    color: theme.darkGray,
    marginLeft: 5,
    fontSize: 14,
  },
  arrowIcon: {
    color: theme.darkGray,
  },
  selected: {},
  textSelectedToggleButton: {
    color: theme.orange,
    fontWeight: "bold",
    fontSize: 30,
  },
  textNotSelectedToggleButton: {
    color: theme.white,
    fontWeight: "bold",
    fontSize: 30,
  },
  toggleButton: {
    width: 300,
    height: 65,
    margin: "20px 20px",
    border: "2px solid " + theme.pureWhite,
    backgroundColor: theme.orange,
    borderRadius: 11,

    "&:disabled": {
      backgroundColor: theme.orange,
      opacity: 0.5,
    },
    "&:hover": {
      backgroundColor: "transparent",
    },
    "&$selected": {
      width: 300,
      height: 65,
      border: "1px solid " + theme.pureWhite,
      backgroundColor: theme.white,
      borderRadius: 11,
      "&:hover": {
        backgroundColor: theme.white,
      },
    },
  },
}));
function DrawerComponent({ onReport }) {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const translate = useTranslate();
  const toggleDrawer = (open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setIsOpen(open);
  };
  const buttonList = [
    {
      name: "OVERVIEW",
      path: "/bi",
      disabled: false,
    },
    {
      name: "REVENUE",
      path: "/bi/revenue",
      disabled: false,
    },
    {
      name: "CUSTOMER",
      path: "/bi/customer",
      disabled: false,
    },
    {
      name: "LOYALTY",
      path: "/bi/loyalty",
      disabled: false,
    },
    {
      name: "RANKING",
      path: "/bi/ranking",
      disabled: false,
    },
    {
      name: "PRODUCT",
      path: "/bi/productandCategory",
      disabled: false,
    },
    {
      name: "INVENTORY",
      path: "path",
      disabled: true,
    },
  ];

  const [toggleButtonValue, setToggleButtonValue] = useState();
  const handleToggleButton = (newValue, pathName) => {
    if (!pathName) return;

    if (toggleButtonValue === newValue) {
      setIsOpen(false);
      setToggleButtonValue(toggleButtonValue);
    } else {
      setToggleButtonValue(newValue);
      history.push({
        pathname: pathName,
      });
    }
  };
  return (
    <Box>
      <Box
        className={
          onReport
            ? classes.onReportContainer
            : [classes.container, classes.fullStyleContainer]
        }
        role="presentation"
        onClick={() => toggleDrawer(false)}
        onKeyDown={() => toggleDrawer(false)}
      >
        {onReport ? (
          <Button className={classes.button} onClick={toggleDrawer(true)}>
            <ArrowForwardIcon className={classes.arrowIcon} />
          </Button>
        ) : (
          <Button
            className={classes.fullStyleButton}
            onClick={toggleDrawer(true)}
          >
            <Typography className={classes.moreReport}>
              {translate("ra.text.bi.moreReport")}
            </Typography>
            <ArrowForwardIcon
              className={classes.arrowIcon}
              style={{ marginLeft: 5 }}
            />
          </Button>
        )}
      </Box>

      <SwipeableDrawer
        anchor="left"
        open={isOpen}
        onClose={toggleDrawer(false)}
        onBackdropClick={toggleDrawer(true)}
      >
        <Box className={classes.background}>
          {buttonList.map((button, index) => {
            return (
              <Box key={index + "list-of-drawer"}>
                <ToggleButton
                  disabled={button.disabled}
                  key={index}
                  value={button.name}
                  onClick={(_, newValue) => {
                    handleToggleButton(newValue, button.path);
                  }}
                  selected={location.pathname === button.path}
                  classes={{
                    root: classes.toggleButton,
                    selected: classes.selected,
                  }}
                >
                  <Typography
                    className={
                      location.pathname === button.path
                        ? classes.textSelectedToggleButton
                        : classes.textNotSelectedToggleButton
                    }
                  >
                    {button.name}
                  </Typography>
                </ToggleButton>
              </Box>
            );
          })}
        </Box>
      </SwipeableDrawer>
    </Box>
    
  );
}

export default DrawerComponent;
